var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "switch_wrap" }, [
    _c("div", { staticClass: "study_header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "course_title" }, [
        _c("p", { attrs: { title: _vm.courseName } }, [
          _vm._v(_vm._s(_vm.courseName))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "class_name",
          attrs: { title: _vm.$route.query.className }
        },
        [
          _vm._v(
            _vm._s(_vm.$route.query.className ? "班级：" : "") +
              _vm._s(_vm.$route.query.className)
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-user" },
        [
          _c(
            "el-dropdown",
            {
              attrs: { "show-timeout": 0 },
              on: { command: _vm.handleCommand }
            },
            [
              _c("div", { staticClass: "user-name el-dropdown-link" }, [
                _c("div", { staticClass: "imgBox" }, [
                  _c("img", { attrs: { src: _vm.imgUrl } })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "login-name", attrs: { title: _vm.name } },
                  [_vm._v(_vm._s(_vm.name))]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", { attrs: { command: "d" } }, [
                    _vm._v("退出")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tab_list_preview" }, [_vm._v("统计")])
    ]),
    _vm._v(" "),
    _c("main", [_c("router-view")], 1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", { attrs: { src: "/static/images/logo_new.png", alt: "" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75160d1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75160d1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_educa_module/educa/classStatistics/statisticsPage.vue
// module id = null
// module chunks = 